import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faCheck } from '@fortawesome/free-solid-svg-icons';

interface ModuleCardProps {
  title: string;
  subtitle?: string;
  thumbnail: string;
  progress?: number;
  href: string;
  lessonCount?: number;
  watchedCount?: number;
}

const ModuleCard: React.FC<ModuleCardProps> = ({
  title,
/*
  subtitle,
*/
  thumbnail,
  progress = 0,
  href,
  lessonCount,
  watchedCount = 0
}) => {
  const isCompleted = progress === 100;

  return (
    <Link
      to={href}
      className="group bg-white dark:bg-gray-800 rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden flex flex-col lg:flex-row h-full lg:h-48"
      onClick={() => console.log('ModuleCard clicked, navigating to:', href)}
    >
      <div className="aspect-video lg:w-80 relative overflow-hidden bg-gray-100 dark:bg-gray-700 flex-shrink-0">
        <img
          src={thumbnail}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjIyNSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iNDAwIiBoZWlnaHQ9IjIyNSIgZmlsbD0iIzM3NDM1MSIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSIgZmlsbD0iI2ZmZiIgZm9udC1mYW1pbHk9InNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMjAiPkNvbWluZyBTb29uPC90ZXh0Pjwvc3ZnPg==';
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center">
            <FontAwesomeIcon icon={faPlay} className="w-6 h-6 text-gray-900 ml-1" />
          </div>
        </div>
        {isCompleted && (
          <div className="absolute top-3 right-3 w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">
            <FontAwesomeIcon icon={faCheck} className="w-4 h-4 text-white" />
          </div>
        )}
      </div>

      <div className="p-5 flex flex-col flex-1 lg:justify-between">
        <div>
          <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-1 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors">
            {title}
          </h3>

          {/*{subtitle && (
            <div className="mb-3 overflow-hidden">
              <p className="text-sm text-gray-600 dark:text-gray-400 line-clamp-3 lg:line-clamp-4">
                {subtitle}
              </p>
            </div>
          )}*/}

          {lessonCount !== undefined && (
            <div className="text-sm text-gray-500 dark:text-gray-400 mb-3">
              {watchedCount} von {lessonCount} Lektionen abgeschlossen
            </div>
          )}
        </div>

        <div className="space-y-2 mt-auto">
          <div className="flex items-center justify-between text-sm">
            <span className="text-gray-600 dark:text-gray-400">Fortschritt</span>
            <span className="font-medium text-gray-900 dark:text-gray-100">{progress}%</span>
          </div>

          <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2 overflow-hidden">
            <div
              className={`h-full transition-all duration-500 ${
                isCompleted
                  ? 'bg-green-500'
                  : 'bg-blue-600'
              }`}
              style={{ width: `${progress}%` }}
            />
          </div>

          <div className="mt-4">
            <span className="inline-flex items-center text-sm font-medium text-blue-600 dark:text-blue-400 group-hover:text-blue-700 dark:group-hover:text-blue-300">
              {isCompleted ? 'Wiederholen' : progress > 0 ? 'Weiter lernen' : 'Los geht\'s'}
              <svg className="ml-1 w-4 h-4 transition-transform group-hover:translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ModuleCard;
